import {BaseService} from '../baseService.js';

/* 
 * Handles Admin tractors, trailers, and drivers
 */
export class AdminUnitService extends BaseService {

	constructor() {	
		super();
	}
	
	//drivers
	async getDrivers(companyId, paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		var data = await this.makeGETRequest('/api/resource/admin-drivers/' + companyId  + params);
		return data;
	}	
	
	async deleteStageDriver(companyId, ids) {		
		var result = await this.makeDELETERequest('/api/resource/admin-drivers/' + companyId + '/stage', ids);		
		return result;
	}
	
	async deleteDriversBulk(companyId, deleteRequest) {		
		var result = await this.makeDELETERequest('/api/resource/admin-drivers/' + companyId + '/bulk', deleteRequest);		
		return result;
	}	
	
	
	//trailers
	async getTrailers(companyId, paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		var data = await this.makeGETRequest('/api/resource/admin-trailers/' + companyId  + params);
		return data;
	}
	
	async deleteStageTrailers(companyId, ids) {		
		var result = await this.makeDELETERequest('/api/resource/admin-trailers/' + companyId + '/stage', ids);		
		return result;
	}
	
	async deleteTrailersBulk(companyId, deleteRequest) {		
		var result = await this.makeDELETERequest('/api/resource/admin-trailers/' + companyId + '/bulk', deleteRequest);		
		return result;
	}	
		
	//tractors
	async getTractors(companyId, paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		var data = await this.makeGETRequest('/api/resource/admin-tractors/' + companyId  + params);
		return data;
	}	
	
	async activateTractor(companyId, ids) {	
		var result = await this.makePUTRequest('/api/resource/admin-tractors/' + companyId + '/activate', ids);
		return result;
	}	

	async inactivateTractor(companyId, ids) {	
		var result = await this.makePUTRequest('/api/resource/admin-tractors/' + companyId + '/inactivate', ids);
		return result;
	}	
	
	async manualBillTractor(companyId, ids) {	
		var result = await this.makePUTRequest('/api/resource/admin-tractors/' + companyId + '/billing-manual', ids);
		return result;
	}	

	async autoBillTractor(companyId, ids) {	
		var result = await this.makePUTRequest('/api/resource/admin-tractors/' + companyId + '/billing-auto', ids);
		return result;
	}
	
	async mergeTractor(mergeRequest) {	
		var result = await this.makePUTRequest('/api/resource/admin-tractors/merge', mergeRequest);
		return result;
	}
	
	async deleteStageTractors(companyId, ids) {		
		var result = await this.makeDELETERequest('/api/resource/admin-tractors/' + companyId + '/stage', ids);		
		return result;
	}	
	
	async deleteTractorsBulk(companyId, skipLocks, deleteRequest) {		
		var lockSkipParam = '';
		if (skipLocks) {
			lockSkipParam = '?skipDataLockCheck=true';
		}				
		var result = await this.makeDELETERequest('/api/resource/admin-tractors/' + companyId + '/bulk' + lockSkipParam, deleteRequest);		
		return result;
	}		
	
	async deleteMPGOverrides(deleteRequest) {		
		var result = await this.makeDELETERequest('/api/resource/admin-tractors/mpg-overrides', deleteRequest);		
		return result;
	}
	
};


